import uniqBy from 'lodash.uniqby';
import { analysesApi } from '@/api';
import { escapeRegExp } from './columnMappings';

// The fields an analysis is searched by, together: one search box, no toggle.
const ANALYSIS_SEARCH_FIELDS = Object.freeze(['code', 'description']);

// Analyses of the user's laboratories (`GET /analyses`, C12) whose code or
// description contains `text`, each once.
export async function searchAnalyses(text) {
  const query = escapeRegExp(text);
  const responses = await Promise.all(
    ANALYSIS_SEARCH_FIELDS.map((field) =>
      analysesApi.autocompleteFetch(field, query)
    )
  );
  return uniqBy(
    responses.flatMap(({ data }) => data),
    'id'
  );
}
